/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const Favorite = (props: any) => (

<svg {...props}   viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.3839 6.56126L11.9999 7.44856L12.616 6.56132C12.9471 6.08457 13.3713 5.68025 13.8606 5.37554C14.4981 4.97853 15.2469 4.75 16.05 4.75C18.3597 4.75 20.25 6.65171 20.25 9.01987C20.25 11.702 18.7127 14.0046 16.8503 15.8018C14.9978 17.5895 12.9213 18.7808 12.0653 19.2327C12.0217 19.2558 11.9783 19.2558 11.9347 19.2327C11.0787 18.7808 9.00221 17.5895 7.14966 15.8018C5.28729 14.0045 3.75 11.702 3.75 9.01987C3.75 6.65173 5.64041 4.75 7.95 4.75C8.75321 4.75 9.50203 4.97852 10.1395 5.3755C10.6288 5.68021 11.0529 6.08452 11.3839 6.56126Z" stroke="inherit" strokeWidth="2"/>
</svg>
);

export default Favorite;